export const TrendData= [
    {
        name: "Minions",
        shares: 97,
    },
    {
        name: "Avengers",
        shares: 80.5,
    },
    {
        name: "batman",
        shares: 75.5,
    },
    {
        name: "Reactjs",
        shares: 72,
    },
    {
        name: "Elon Musk",
        shares: 71.9,
    },
    {
        name: "Jordan peterson",
        shares: 20,
    }
];
